/* eslint-disable 学员 和 家长的反馈分开 */
<template>
<div>
  <h3 style="text-align:center">本周学习反馈</h3>
  <div>亲爱的家长，成功的路上并不拥挤，因为坚持的人并不多。这一周孩子的学习内容和相关的启蒙内容是否有完成呢？<strong style="color:orange">猩球启蒙计划</strong>需要根据宝贝对本周学习资料的<strong style="color:orange">反馈信息</strong>和相应兴趣度为后续提供更加个性化的学习路线和规划，温馨提示：一定需要跟孩子完成本周任务后在进行反馈哟! 以下反馈可能会花费您1-2分钟时间: </div>
  <div class="breakline"></div>


  <div v-if="student_questions.length">
    <div><h3 class="ques_section_title">孩子表现反馈</h3></div>
    <div v-for="(ques, index) in student_questions" v-bind:key="index" class="flex-row">
      <div class="flex ques_header"><span class="ques_order">{{index+1}}</span></div>
      <div style="width: 100%">
        <question :question="ques" v-on:setAnswer="getAnswer" :id="ques.id"></question>
      </div>
    </div>
  </div>

  <div v-if="parent_questions.length">
    <div><h3 class="ques_section_title">家长表现反馈</h3></div>
    <div v-for="(ques, index) in parent_questions" v-bind:key="index" class="flex-row">
      <div class="flex ques_header"><span class="ques_order">{{index+1 + student_questions.length}}</span></div>
      <div style="width: 100%">
        <question :question="ques" v-on:setAnswer="getAnswer" :id="ques.id"></question>
      </div>
    </div>
  </div>

  <div style="text-align:center; margin-top: 10px; color:orange">
    <button @click="submit" class="feedback">提交</button>
  </div>
</div>
</template>

<script>
require('@/assets/css/common-flex.css')
require('@/assets/css/feedback.css')
import Question from '@/components/template/question/Question'
import BaseVue from '@/components/BaseVue'

export default {
  name: 'Feedback',
  extends: BaseVue,
  components: {Question},
  data () {
    return {
      questions: [
        {id: 1, ques_type: 1, body: '本周的启蒙故事/动画您是否给孩子读完? *', option: ['是', '否']},
        {id: 2, ques_type: 1, body: '孩子是否对本周内容感兴趣? *', option: ['是', '否']}, // date
        {id: 3, ques_type: 1, body: '孩子是否用自己的语言复述整个故事? *', option: ['是', '否']}, // slider
        {
          id: 4,
          ques_type: 1,
          body: '您是否跟孩子一起制作本周主题相关的手工教具？*',
          option: ['是','否']
        },
        {
          id: 5,
          ques_type: 1,
          body: '孩子是否积极参与制作本周主题相关相应的手工教具? *',
          option: ['是','否']
        },
        {
          id: 6,
          ques_type: 1,
          body: '孩子是否想要重复阅读/观看这个启蒙资料? *',
          option: ['是','否']
        },
        {
          id: 7,
          ques_type: 1,
          body: '孩子是否用手工教具能够跟着家长一起演绎整个故事? *',
          option: ['是','否']
        },
        {
          id: 8,
          ques_type: 1,
          body: '孩子是否能够改编故事或创造情节演绎出来?【大龄】 *',
          option: ['是','否']
        },
        {
        id: 9,
        ques_type: 1,
        body: '您对本周的英文启蒙材料打几分? *',
        option: [1,2,3,4,5]
        },
        {
        id: 10,
        ques_type: 0,
        body: '关于本学习材料，您还有什么其他的建议或反馈? *',
        },
      ],
      student_questions: [],
      parent_questions: [],
      answers: {},
      isCompleteAnswer: false
    }
  },
  methods: {
    getAnswer: function (qid, ans) {
      this.answers[qid] = ans
    },
    submit: function () {
      this.checkAnswer(this.student_questions)
      this.checkAnswer(this.parent_questions, this.student_questions.length)
      if (!this.isCompleteAnswer) return
      console.table('The lastest answer: ')
      console.table(this.answers)
      this.$router.push({path: '/target'})
    },
    checkAnswer: function (questions, from_order=0) {
      for (let i = 0; i < questions.length; i++) {
        let qid = questions[i].id
        let ans = this.answers[qid]
        if (ans === undefined || ans.length === 0) {
          let msg = '第' + (i+1 + from_order) + '题还未作答'
          console.log('Question ' + qid + ' is not answered!')
          alert(msg)
          this.isCompleteAnswer = false
          return
        }
      }
      this.isCompleteAnswer = true
    },
    splitQuestions: function () {
      for (let i = 0; i < this.questions.length; i++) {
        let ques = this.questions[i]
        if (ques.role === '家长') {
          this.parent_questions.push(ques)
        } else {
          this.student_questions.push(ques)
        }
        // if (i.role === '学生') this.student_questions.push(ques)
      }
      // console.log('parent_questions length: ' + this.parent_questions.length)
      // console.log('student_questions length: ' + this.student_questions.length)
    }
  },
  created: function () {
    let book_id = this.$route.params.id
    if (book_id === undefined) {
      this.splitQuestions()
      return
    }
    let url = this.APIHOST + 'bookfeedback/' + book_id + '?format=json'
    let that = this;
    this.queryData(url, function (data) {
      that.questions = data.feedback
      that.splitQuestions()
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Feedback.vue